<vs-dialog [config]="{ dialogContainerClass: 'max-w-[560px]' }">
  <vs-dialog-header
    [config]="{
      mode: 'simple',
      showDivider: true,
      icon: 'scales-02',
      iconTheme: 'primary',
      title: readOnly ? config.adjust.historyTitle : config.adjust.title,
      subtitle: readOnly ? '' : config.adjust.subtitle
    }"
  ></vs-dialog-header>

  <form *ngIf="line" class="flex flex-col gap-4 p-4" [formGroup]="form">
    <div class="flex justify-between text-sm border rounded-xl px-4 py-3" data-testid="adjust-requested">
      <span class="text-gray-500">{{ config.adjust.requested }}</span>
      <span class="text-gray-900">
        {{ line.quantity ?? '-' }} {{ unitLabel(line) }} · {{ formatAmount(line.requestedRate) }} · {{
        formatAmount(line.requestedAmount) }}
      </span>
    </div>

    <ng-container *ngIf="!readOnly">
      <div class="grid grid-cols-3 gap-4">
        <vs-form-field [config]="{ label: config.adjust.allowedQuantity }">
          <input vsInput type="number" min="0" step="any" formControlName="allowedQuantity" />
        </vs-form-field>

        <vs-form-field [config]="{ label: config.adjust.allowedRate }">
          <input vsInput type="number" min="0" step="0.01" formControlName="allowedRate" />
        </vs-form-field>

        <vs-form-field [config]="{ label: config.adjust.allowedAmount }">
          <input vsInput type="number" min="0" step="0.01" formControlName="allowedAmount" />
        </vs-form-field>
      </div>

      <div class="grid grid-cols-2 gap-4">
        <vs-form-field [config]="{ label: config.adjust.source }">
          <vs-select
            vsInput
            formControlName="recommendationSource"
            [config]="{ placeholder: config.adjust.sourcePlaceholder }"
          >
            <li *ngFor="let source of sources" vs-select-option [value]="source">{{ config.sources[source] }}</li>
          </vs-select>
        </vs-form-field>

        <vs-form-field [config]="{ label: config.adjust.sourceVersion }">
          <input
            vsInput
            type="text"
            formControlName="sourceVersion"
            [placeholder]="config.adjust.sourceVersionPlaceholder"
          />
        </vs-form-field>
      </div>

      <vs-form-field [config]="{ label: config.adjust.reason }">
        <textarea vsInput formControlName="reason" [placeholder]="config.adjust.reasonPlaceholder"></textarea>
      </vs-form-field>
    </ng-container>

    <div class="flex flex-col gap-2" data-testid="adjust-history">
      <p class="text-sm font-medium text-gray-700">{{ config.adjust.history }}</p>
      <p *ngIf="!history.length" class="text-sm text-gray-500">{{ config.adjust.noHistory }}</p>
      <div *ngFor="let entry of history" class="border rounded-lg px-3 py-2 text-sm" data-testid="adjust-history-entry">
        <div class="flex justify-between gap-2 text-gray-500">
          <span
            >v{{ entry.version }} · {{ entry.next.recommendationSource ? config.sources[entry.next.recommendationSource]
            : '-' }}</span
          >
          <span
            >{{ entry.createdBy?.displayName || config.adjust.someone }} · {{ entry.created | date: 'medium' }}</span
          >
        </div>
        <p class="text-gray-900">
          {{ formatAmount(entry.previous.allowedAmount) }} → {{ formatAmount(entry.next.allowedAmount) }}
        </p>
        <p class="text-gray-600">{{ entry.reason }}</p>
      </div>
    </div>
  </form>

  <div class="flex justify-end gap-2 px-4 pb-4">
    <button vs-button appearance="outline" (click)="close()">
      {{ readOnly ? config.adjust.close : config.adjust.cancel }}
    </button>
    <button *ngIf="!readOnly" vs-button theme="primary" [disabled]="form.invalid || saving" (click)="save()">
      {{ config.adjust.save }}
    </button>
  </div>
</vs-dialog>
